module.exports = __webpack_public_path__ + "img/slider3.b0579be3.gif";